
import { useCallback, useState, useMemo } from "react";
import axiosInstance from "../utils/axios";

export default function useRegularRequest({

    onErrorCallback = null,
    onErrorAsyncCallback = null,

    onSuccessCallback = null,
    onSuccessAsyncCallback = null,

    initialLoadingState = false,

    apiContext = null,
    requestHandler: customRequestHandler = null,

} = {}) {

    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(initialLoadingState)

    const clearData = useCallback(() => setData(null),[setData])

    const apiCallback = useCallback((filter) => {

        if (!apiContext) return null

        const {
            options = null,
            endpoint = null,
            method: rawMethod = null,
        } = apiContext ?? {}

        const method = rawMethod?.toLowerCase?.()

        if (method?.toLowerCase() === 'post') 
            return axiosInstance?.[method?.toLowerCase()]?.(endpoint, filter, options)
        if (method?.toLowerCase() === 'get') 
            return axiosInstance?.[method?.toLowerCase()]?.(endpoint, {...options, params: filter })
        console.error(`Invalid method for fetching: ${method}`)
        return null

    }, [apiContext])

    const requestHandler = useMemo(() => {
        if (apiCallback === null && customRequestHandler === null) return null
        if (customRequestHandler) return customRequestHandler
        return apiCallback
    }, [apiCallback, customRequestHandler])

    const callRequest = useCallback(async (...queryArgs) => {
        try {
            setIsLoading(true)
            const result = await requestHandler?.(...queryArgs)
            if (result) {
                setData(result?.data?.data ?? result?.data ?? null)
                if(onSuccessCallback) return onSuccessCallback(result)
                if(onSuccessAsyncCallback) return await onSuccessAsyncCallback(result)
            }
            return result
        } catch (error) {
            onErrorCallback?.()
            onErrorAsyncCallback?.()
            console.error(error)
            throw error
        } finally {
            setIsLoading(false)
        }

    },[
        setData,
        requestHandler,
        onErrorCallback,
        onSuccessCallback,
        onErrorAsyncCallback,
        onSuccessAsyncCallback,
    ])
    
    const queryRequest = useCallback(async (...queryArgs) => {
        try {
            setIsLoading(true)
            return await callRequest?.(...queryArgs)
        } finally {
            setIsLoading(false)
        }
    }, [
        callRequest,
        setIsLoading,
    ])

    return {
        data, 
        clearData,
        callRequest,
        queryRequest,
        isLoading, setIsLoading,
    }
}